<div class="join vertical">
    <button (click)="navigate('generateUploadUrl')" [ngClass]="{'active':item==0}" class="join-item">Generate Upload Url</button>
    <button (click)="navigate('UploadFirmware')" [ngClass]="{'active':item==2}" class="join-item">Upload Firmware</button>
    <button (click)="navigate('ManageTokens')" [ngClass]="{'active':item==3}" class="join-item">Manage Tokens</button>
    <button (click)="navigate('AllFiles')" [ngClass]="{'active':item==4}" class="join-item">All Files</button>
</div>